import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react"; // import classnames from "classnames";

import Swiper from "react-id-swiper"; // components

import withUserMenu from "../../UserMenu.store"; // components

import Icon from "../../../Icon";
import Package from "../../../Package";
import styles from "./Compare.module.scss";
export var CompareComponent = function CompareComponent(a) {
  var b = a.userMenu,
      c = a.onPackageClick,
      d = useState(),
      e = _slicedToArray(d, 2),
      f = e[0],
      g = e[1],
      h = _slicedToArray(b, 2),
      i = h[0],
      j = h[1],
      k = i.compare || [];

  useEffect(function () {
    f && k.length && f.updateSlides();
  }, [k.length, f]);
  return i.compare ? /*#__PURE__*/React.createElement("div", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, k.length ? /*#__PURE__*/React.createElement(Swiper, {
    slidesPerView: 4.1,
    mousewheel: !0,
    spaceBetween: 20,
    freeMode: !0,
    getSwiper: g,
    breakpoints: {
      790: {
        slidesPerView: 1.1,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 2.1,
        spaceBetween: 20
      },
      1545: {
        slidesPerView: 3.1,
        spaceBetween: 20
      }
    }
  }, k.map(function (a) {
    return /*#__PURE__*/React.createElement("div", {
      key: a.slug,
      className: styles.package
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.toolbar
    }, /*#__PURE__*/React.createElement("button", {
      className: styles.trash,
      onClick: function onClick() {
        return j.removeCompare(a.slug);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "trash"
    }))), a.unavailable ? /*#__PURE__*/React.createElement("div", {
      className: styles.unavailable
    }) : null, /*#__PURE__*/React.createElement(Package, {
      package: a,
      className: styles.item,
      onClick: c,
      disableFlyerBtn: !0,
      disableViewBtn: !0
    }));
  })) : /*#__PURE__*/React.createElement("p", {
    className: styles.paragraph
  }, "Press \u2018compare\u2019 in order to compare packages."))) : null;
};
export var Compare = withUserMenu(CompareComponent);
export default Compare;